<template>
  <div>
    <v-card>
      <v-card-title>Probations</v-card-title>
      <v-col class="pt-0">
        <v-row class="px-4">
          <v-col class="py-0 pt-3">
            <v-autocomplete
              v-model="type"
              v-validate="'required'"
              label="Probation Type"
              multiple
              clearable
              deletable-chips
              :error-messages="errors.collect('type')"
              data-vv-name="type"  
              data-vv-as="type"
              chips
              :items="types"
              item-text="type"
              item-value="value"
              hide-selected
            />
          </v-col>
          <v-col cols="2">
            <v-btn
              class="mx-3"
              :loading="progressing"
              color="primary"
              @click="generate"
            >
              <v-icon class="mr-1">
                mdi-download
              </v-icon>
              Download
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-card> 
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },

    data () {
      return {
        progressing: false,
        type: [],
        types: [
          { type: 'New Position', value: 'new position' },
          { type: 'Normal Hire (New Hire / Rehire)', value: 'normal hire' },
        ],
      }
    },

    methods: {
      generate () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            
            this.progressing = true

            this.$api.probationReports().probationReport({ types: this.type })
              .then(res => {
                let blob = new Blob([res.data], { type: res.data.type })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', 'Probation Report.xlsx')
                link.click()

                this.progressing = false
              })
          })
      },
    },
  }
</script>
